const emotionalMessages = [
  {
    1: [
      `Hi @@studentName! Ready to test your skills? I wish you the best!`,
      ` It's time to test @@studentName! Don't worry you have my best :) `,
      `Hi @@studentName, It's testing time!! I wish you my best :)`,
    ],
    2: [
      "Keep practicing; each session helps you grow. Focus on the areas that challenge you and watch your progress unfold.",
      "Every session is a step forward. Identify your weak points and work on them. Improvement is a journey, not a destination.",
      "Practice makes progress. Use this session to understand your mistakes and learn from them. You're on the right track.",
      "Completing this session is a step in the right direction. Analyze your performance and focus on improvement areas.",
      "Each practice session offers valuable lessons. Review your work, identify areas for improvement, and continue your journey to success.",
    ],
    3: [
      "Nice work! You're making solid progress. Keep practicing and refining your skills, and you'll see even better results soon!",
      "Great effort! You're on the right track. With continued practice, you'll achieve even greater success. Keep up the good work!",
      "Well done! Your dedication is paying off. Keep pushing yourself, and you'll continue to improve and reach new heights!",
      "Good job! You're getting better with each practice. Stay focused and keep working hard, and you'll see amazing progress!",
      "Impressive effort! You're showing significant improvement. Keep honing your skills and maintain this positive trajectory for even better results!",
    ],
    4: [
      "Amazing job! Your dedication and hard work are clearly paying off. Keep up the great work and continue to excel!",
      "Fantastic effort! Your progress is evident. Stay focused and keep pushing forward. You're doing an excellent job!",
      "Well done! Your consistent practice is leading to great results. Keep believing in yourself and continue this positive momentum!",
      "Excellent work! Your commitment to improving is showing. Stay motivated and keep striving for even greater achievements!",
      "Great job! Your dedication is making a difference. Keep up the wonderful effort and you'll continue to achieve outstanding results!",
    ],
    5: [
      `Hi @@studentName! Let's dive into our first challenge together!`,
      `Hi @@studentName! Start your engines as we are about to begin a fun ride!`,
      `Hey @@studentName! Ready to sharpen your skills? Let's begin`,
    ],
    6: [
      "Great effort! Keep practicing, and you'll improve. Remember, every mistake is a step towards success. Let's tackle the next homework with confidence!",
      "Don't worry about the score, focus on learning. You're doing great, keep going! The more you practice, the better you'll become. On to the next homework!",
      "Mistakes help us learn. Keep your spirits high and give your best. You've got this! Let's move to the next challenge and show what you can do!",
      "Stay positive! Every try gets you closer to your goal. Keep practicing and believe in yourself. Let's continue to the next question with determination!",
      "You're doing well! Practice makes perfect, so don't give up. Keep pushing forward and improving. Let's face the next homework with a positive mindset!",
    ],
    7: [
      "Fantastic job! Your hard work and dedication are paying off. Keep it up, and you'll continue to achieve great results!",
      "Excellent work! Your effort and focus are showing amazing progress. Stay motivated and keep aiming for even greater success!",
      "Well done! Your consistent practice is leading to impressive outcomes. Keep pushing forward and maintain this positive momentum!",
      "Great job! Your commitment to learning is yielding wonderful results. Keep striving for excellence and you'll go even further!",
      "Amazing effort! Your dedication is clearly making a difference. Stay on this path and you'll achieve even more remarkable success!",
    ],
    8: [
      "Well done on your progress! Keep practicing, and you'll continue to improve. You're on the right track!",
      "Great job reaching this milestone! With consistent effort, you'll keep climbing higher. Keep up the fantastic work!",
      "Impressive work! You've made solid progress. Keep pushing forward, and you'll see even greater results. Believe in yourself!",
      "Nice effort! You're getting closer to your goal. Keep practicing and stay motivated. Success is within your reach!",
      "You're making great strides! Keep up the good work, and you'll achieve even more. Stay focused and keep going!",
    ],
    9: [
      `Is curious @@studentName ready for an adventure? Let's begin!`,
      `Have you had your energy snack, @@studentName? Because you are going to need it before we begin our learning journey!`,
      `I am as excited as you are @@studentName! Let's learn together :)`,
    ],
    10: [
      "You're making progress. Keep pushing forward and applying what you've learned. Improvement comes with each step you take.",
      "Every effort counts. Continue to move ahead and build on what you've learned. You're growing with each question.",
      "Stay motivated! Each question you tackle helps you learn more. Keep moving forward and you'll see improvement.",
      "Learning takes time. Keep advancing and applying your knowledge. Every question answered is a step towards better understanding.",
      "Keep going! Each question helps you grow and learn. Stay focused and continue to build your understanding.",
    ],
    11: [
      "You've made a solid start with the questions. Keep reviewing the material and practicing to improve your understanding even more.",
      "Nice effort on completing the questions! Continue to focus on the videos, and your comprehension will grow stronger.",
      "Good job completing the questions! Keep watching the videos and practicing, and you'll see even more progress.",
      "You're making progress with the questions. Stay committed to watching the videos, and your understanding will keep improving.",
      "Well done finishing the questions! Keep up the practice and video review, and you'll continue to enhance your skills.",
    ],
    12: [
      "Great job! Your understanding is impressive. Keep watching and learning, and continue to deepen your knowledge. You're doing awesome!",
      "Fantastic work! Your answers show strong comprehension. Keep engaging with the material and your progress will keep growing!",
      "Wonderful effort! Your grasp of the concepts is evident. Stay curious and keep exploring the videos. You're on the right track!",
      "Impressive understanding! Your focus and dedication are showing. Keep watching and learning, and your knowledge will continue to expand!",
      "Awesome job! Your answers reflect a solid understanding. Keep up the dedication and you'll keep achieving great results!",
    ],
    14: [
      `Hey @@studentName, happy to get you started! To begin, select subject, followed bychapters, subtopics and the homeworks. `,
    ],
    15: [
      `Here are the class updates on lessons, teacher recommendations, and activities to keep you prepared and connected.`,
    ],
    20: [
      `Hi, here's an interesting activity @@experientialactivitytitle on the chapter @@topicname . Check the description and download the reference material for detailed instructions. Hands-on! Minds-on! Ready?`,
    ],
    21: [
      `Hang on tight @@studentName ! Navigating through the clouds to upload your awesome activity in a moment....`,
    ],
    22: [`Great job @@studentName on successfully completing the activity.`],
  },
];

export default emotionalMessages;
